/**
 * Shared Slovenian date formatting (UI_GUIDELINES §9): `20. 10. 2026` and
 * `20. 10. 2026 · 23:59`. Prefer these over bare toLocaleString() calls.
 */
const DATE = new Intl.DateTimeFormat('sl-SI', { day: 'numeric', month: 'numeric', year: 'numeric' });
const TIME = new Intl.DateTimeFormat('sl-SI', { hour: '2-digit', minute: '2-digit' });
const LONG_DATE = new Intl.DateTimeFormat('sl-SI', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });

export function formatDate(iso?: string | null): string {
  if (!iso) return '—';
  return DATE.format(new Date(iso));
}

export function formatDateTime(iso?: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return `${DATE.format(d)} · ${TIME.format(d)}`;
}

/** `petek, 17. oktober 2026` — for page eyebrows. */
export function formatLongDate(date: Date = new Date()): string {
  return LONG_DATE.format(date);
}

/** Whole days from now until `iso` (negative when past); null when unset. */
export function daysUntil(iso?: string | null): number | null {
  if (!iso) return null;
  const ms = new Date(iso).getTime() - Date.now();
  return Math.ceil(ms / 86_400_000);
}

/** `še 3 dni`, `še 1 dan`, `danes`, `poteklo` — relative only under a week, else the date (UI_GUIDELINES §9). */
export function describeDeadline(iso?: string | null): string {
  const days = daysUntil(iso);
  if (days === null) return '—';
  if (days < 0) return 'poteklo';
  if (days === 0) return 'danes';
  if (days > 7) return formatDate(iso);
  if (days === 1) return 'še 1 dan';
  if (days === 2) return 'še 2 dni';
  return `še ${days} dni`;
}
